<template>
  <div class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h4 v-text="$t('status')" class="mb-3" />
        <div class="vx-row">
          <div v-for="(status, key) in exportFilter.statuses" v-bind:key="'status_' + key" class="mb-3 vx-col sm:w-1/3 md:w-1/3 w-full">
            <vs-checkbox :value="status.value" v-model="status.selected">{{ $t(`auto_call_system_${status.value.toLowerCase().replace(' ', '_')}`) }}</vs-checkbox>
          </div>
        </div>
        <div class="mb-3">
          <div class="vx-col w-full">
            <label class="vs-input--label" v-text="$t('date_filter_from')" />
            <date-picker v-model="exportFilter.dateFrom" :model="exportFilter.dateFrom" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
          </div>
        </div>
        <div class="mb-3">
          <div class="vx-col w-full">
            <label class="vs-input--label" v-text="$t('date_filter_to')" />
            <date-picker v-model="exportFilter.dateTo" :model="exportFilter.dateTo" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventBus } from '@/../eventbus.js'
import DatePicker from '@/components/form-inputs/DatePicker'
import AutoCallSystem from '@/models/AutoCallSystem'

export default {
  name: 'Shared.AutoCallSystem.ExportData',
  components: {
    DatePicker
  },
  data () {
    return {
      exportFilter: {
        dateFrom: '',
        dateTo: '',
        statuses: []
      },
      companyId: this.$store.getters.userInfo.company.id,
      userId: this.$store.getters.userInfo.id
    }
  },
  mounted () {
    EventBus.$on('initResetFormData', this.initResetFormData)
    EventBus.$on('initExportAutoCallSystemData', this.exportData)
    this.loadSettings()
  },
  methods: {
    async loadSettings () {
      const response = await AutoCallSystem.getCurrentStatus()
      this.exportFilter.statuses = response.data
    },
    async initResetFormData () {
      this.exportFilter = {
        dateFrom: null,
        dateTo: null,
        statuses: []
      }
    },
    async exportData () {
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        const status = []
        this.exportFilter.statuses.forEach(function (data) {
          if (data.selected === true) {
            status.push(data.value)
          }
        })
        await AutoCallSystem.exportAutoCallSystemData(this.companyId, this.userId, language, {dateFrom: this.exportFilter.dateFrom, dateTo: this.exportFilter.dateTo, statuses: status.join(',')})
      } catch (e) {
        this.$alertHelper.error()
      }
    }
  }
}
</script>

<style lang="scss">
#exportButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
